import draftTypes from 'constants/draftTypes';
import { TranslateFn } from 'hooks/useTranslate';
import { draftStatus } from 'modules/_shared/components/Badges/BadgeDraftStatus';
import { draftSafeStatus } from '../constants/draftSafeStatus';
import { draftConvertibleNoteStatus } from '../constants/draftConvertibleNoteStatus';

type GetDraftStatusLabelProps = {
  t: TranslateFn;
  status: string;
  draftType: keyof typeof draftTypes;
  isConverted: boolean;
};

export const getDraftStatusLabel = ({
  t,
  status,
  draftType,
  isConverted,
}: GetDraftStatusLabelProps): string => {
  if (draftType === draftTypes.DRAFT_SAFE) {
    return t(draftSafeStatus.name[status as keyof typeof draftSafeStatus.name]);
  }

  if (draftType === draftTypes.DRAFT_CONVERTIBLE_NOTE) {
    return t(
      draftConvertibleNoteStatus.name[
        status as keyof typeof draftConvertibleNoteStatus.name
      ]
    );
  }

  if (draftType === draftTypes.DRAFT_CAPITAL_INCREASE && isConverted) {
    return t(draftStatus.EXECUTED.label);
  }

  if (draftType === draftTypes.DRAFT_CAPITAL_INCREASE && !isConverted) {
    return t(draftStatus.DRAFT.label);
  }

  if (draftType === draftTypes.DRAFT_BUY_SELL_SHARES && isConverted) {
    return t(draftStatus.EXECUTED.label);
  }

  if (draftType === draftTypes.DRAFT_BUY_SELL_SHARES && !isConverted) {
    return t(draftStatus.DRAFT.label);
  }

  return '';
};
